import { Injectable } from '@angular/core';

export const PAUSED_ACCESS_CODES = ['E_PAUSED_ACCESS', 'E_PAUSED_ACCESS_QUESTIONNAIRE'];

export function isPausedAccess(code: string): boolean {
  return PAUSED_ACCESS_CODES.includes(code);
}

@Injectable()
export class ErrorService {
  error: Error = null;

  constructor() {
    this.error = this.load();
  }

  updateError(error: Error) {
    this.save(error);
  }

  clear() {
    sessionStorage.removeItem('error');
    this.error = null;
  }

  private save(error: Error) {
    this.error = error;
    sessionStorage.setItem('error', JSON.stringify(error));
    return error;
  }

  private load(): Error {
    return JSON.parse(sessionStorage.getItem('error'));
  }
}

export class Error {
  code: string;
  title: string;
  message: string;
}



// WEBPACK FOOTER //
// ./src/app/services/error.service.ts